import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { Module, ModuleSummary } from '../model/models'

export class ModuleAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getModules = this.getModules.bind(this)
    this.getModulesSummary = this.getModulesSummary.bind(this)
  }

  private readonly endpoint = '/modules'

  public getModules(): Promise<Module[]> {
    return this.get<Module[]>(this.endpoint)
      .then((response: AxiosResponse<Module[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getModulesSummary(date: Date): Promise<ModuleSummary[]> {
    return this.get<ModuleSummary[]>(`${this.endpoint}/summary`, {
      params: {
        date_of_execution: date,
      },
    })
      .then((response: AxiosResponse<ModuleSummary[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  public getModulesInfo(date: Date): Promise<Record<string, any>[]> {
    return this.get<Record<string, any>[]>(`dashboard-descriptions`, {
      params: {
        date_of_execution: date,
      },
    })
      .then((response: AxiosResponse<Record<string, any>[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const moduleAPI = new ModuleAPI(httpConfig)
